const STORAGE_KEY = 'error-reload-retries';
const ERROR_REASON_KEY = 'error-reload-retries_reason';

export const errorReload = (error: string, retries = 1) => {
  console.error(error);

  const errRetries: string | null = sessionStorage.getItem(STORAGE_KEY);

  console.log('errorReload()', typeof errRetries, errRetries);

  if (typeof errRetries === 'string') {
    // we have tried before
    if (parseInt(errRetries) >= retries) {
      // ah, give up
      console.log('errorReload() now give up');
      return;
    }

    console.log('errorReload() now try again');

    const retryCounter = parseInt(errRetries) + 1;

    sessionStorage.setItem(STORAGE_KEY, retryCounter.toString());
    sessionStorage.setItem(ERROR_REASON_KEY + retryCounter.toString(), error);
  } else {
    // we have not tried before
    console.log('errorReload() try again');
    sessionStorage.setItem(STORAGE_KEY, '1');
    sessionStorage.setItem(ERROR_REASON_KEY + 1, error);
  }

  window.location.reload();
};
